// removed by extract-text-webpack-plugin
module.exports = {"table-responsive":"table-responsive__3v6aw","yellow":"yellow__2ibPI"};


//////////////////
// WEBPACK FOOTER
// ./styles/elss/elsstable.scss
// module id = 1263
// module chunks = 68